<template>
  <div class="video">
    <player></player>
  </div>
</template>

<script>

import Player from '@/components/Player'

export default {
  name: 'DeviceVideo',
  data () {
    return {}
  },
  components: {
    Player
  }
}
</script>

<style scoped lang="less">
.video {
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  > .float {
    position: absolute;
    right: 0px;
    z-index: 999999;
    cursor: pointer;
    > img {
      cursor: pointer;
    }
  }
}
</style>
